import { HttpInterceptorFn } from '@angular/common/http';

import { authInterceptor } from './auth.interceptor';
import { errorInterceptor } from './error.interceptor';
import { loadingInterceptor } from './loading.interceptor';
import { refreshInterceptor } from './refresh.interceptor';

export { authInterceptor } from './auth.interceptor';
export { errorInterceptor } from './error.interceptor';
export { loadingInterceptor } from './loading.interceptor';
export { refreshInterceptor } from './refresh.interceptor';

/**
 * The HTTP interceptor chain, in order. Lives here rather than inline in
 * app.config.ts so the chain's own spec can assert against the real thing —
 * a spec that repeated the order would keep passing after someone changed it.
 *
 * ORDER IS LOAD-BEARING. A response is handled in reverse, so the LAST entry sees
 * an error first. refreshInterceptor must stay last: that is what lets it retry an
 * expired token before errorInterceptor clears the session and redirects to
 * /launcher. Moving it earlier still compiles, still looks reasonable, and silently
 * returns every token expiry to logging the user out.
 */
export const HTTP_INTERCEPTOR_CHAIN: HttpInterceptorFn[] = [
  authInterceptor,
  loadingInterceptor,
  errorInterceptor,
  refreshInterceptor,
];
